import { connect } from "react-redux";
import LocalStorageHandler from "./local-storage-handler";
import { actionCreators, getCalendar } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
    getLoadFromLocalStorage,
    getUploadedCoverImages,
    getUploadedOwnerPageImages,
} from "ui/store";
import { actionCreators as eventActionCreators } from "event/store";
import { getIsAuthenticated } from "user/store";
import { ApplicationState } from "store";
import { getPostData } from "event/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    loadFromLocalStorage: getLoadFromLocalStorage(state),
    activeNavigationComponent: getActiveNavigationComponent(state),
    isAuthenticated: getIsAuthenticated(state),
    postData: getPostData(state),
    uploadedCoverImages: getUploadedCoverImages(state),
    uploadedOwnerPageImages: getUploadedOwnerPageImages(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...eventActionCreators,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LocalStorageHandler);
